import React from "react";
import * as S from "./index-styled";
import ScheduleBlock from "./working-days";
import ActionsBlock from "./discounts";
import BlogBlock from "./blog";
import AchievesBlock from "./achieves";
import Map from "./map";
import PT from "prop-types";
//import Clients from "./clients";
//import Associates from "./associates";
import { useTheme } from "@/hooks/useTheme";
import { useHistory } from "react-router-dom";
import isempty from "lodash/isEmpty";

const Aside = ({ t, ...props }) => {
  const history = useHistory();
  const theme = useTheme();
  return (
    <S.Wrap>
      {/*<S.ListBlock>
        <Associates
          t={t}
          associates={props.associates}
          isOwner={props.isOwner}
          history={history}
        />
        <S.ListDelim />
        <Clients
          t={t}
          clients={props.clients}
          isOwner={props.isOwner}
          history={history}
        />
      </S.ListBlock>
      */}
      <ActionsBlock
        theme={theme}
        t={t}
        isOwner={props.isOwner}
        discounts={props.discounts}
        modelSearchService={props.modelSearchService}
      />
      <ScheduleBlock
        theme={theme}
        t={t}
        masterId={props.masterId}
        weekSchedule={props.weekSchedule}
        isOwner={props.isOwner}
        openFreeSlots={props.openFreeSlots}
      />
      <S.MapsBlock id="master_location_sect">
        <Map
          t={t}
          isPremium={props.isPremium}
          locale={props.locale}
          isOwner={props.isOwner}
          coords={props.coords}
          masterId={props.masterId}
          history={history}
        />
      </S.MapsBlock>
      <AchievesBlock
        theme={theme}
        t={t}
        isOwner={props.isOwner}
        achieves={props.achieves}
      />
      {!isempty(props.articles) && (
        <BlogBlock
          theme={theme}
          hl={props.hl}
          t={t}
          isOwner={props.isOwner}
          articles={props.articles}
        />
      )}
    </S.Wrap>
  );
};
Aside.propTypes = {
  articles: PT.array,
  clients: PT.array,
  discounts: PT.array,
  associates: PT.array,
  achieves: PT.array,
  isOwner: PT.bool,
  isPremium: PT.bool,
  coords: PT.array,
  weekSchedule: PT.array,
  modelSearchService: PT.object,
  masterId: PT.string,
  locale: PT.string,
  hl: PT.string,

  openFreeSlots: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default Aside;
